import { useTranslation } from '@crehana/i18n';

import locales, { CREATE_AND_EDIT_EMAIL_TEMPLATES, type TKeys } from '../i18n';

export const useTranslationCreateAndEditEmailTemplates = () => {
  const { addResourceBundle, t } = useTranslation<TKeys>(
    CREATE_AND_EDIT_EMAIL_TEMPLATES,
  );

  addResourceBundle(locales);

  return {
    t,
  };
};
